import compose from '@aveneo/frontmoon-utils/lib/hocs/compose';
import { withRouter } from 'next/router';
import LoginForm from './LoginForm';
import connectContainer from './LoginFormContainer';

export default compose(
    connectContainer,
    withRouter
)(LoginForm);
